"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _eqmodJsQrcodelib = require("eqmod-js-qrcodelib");

var _HttpRequest = require("../../../utils/HttpRequest");

var _BuildConstants = require("../../../utils/BuildConstants");

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _DateTimeHelper = require("../../../helpers/DateTimeHelper");

var _Button = _interopRequireDefault(require("../Button"));

var _QRCodeLogin = _interopRequireDefault(require("./QRCodeLogin.scss"));

var _strings = require("./strings");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var START_TIMER = 240; // seconds (= 4min)

var QD_QR_CODE_TEMPLATE = {
  actionParams: {
    code: 'Digitale Transformation',
    email: '',
    nickname: '',
    password: ''
  },
  systemAction: 'registerQdUser'
};

var QRCodeLogin = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(QRCodeLogin, _Component);

  var _super = _createSuper(QRCodeLogin);

  function QRCodeLogin() {
    var _this;

    (0, _classCallCheck2["default"])(this, QRCodeLogin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      loading: true,
      error: '',
      timer: START_TIMER,
      start: true
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getQDReferrer", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getReferrer", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var token, response, data, configId;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _this.setState({
                loading: true,
                start: false
              });

              _context2.next = 4;
              return _RegisterInstance["default"].getAccessToken('dataStore:write');

            case 4:
              token = _context2.sent;
              console.log(token);
              _context2.next = 8;
              return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/rest/api/v1/dataStore/createAuthorizationMessage"), {}, {}, false, 60000, null, 'Bearer ' + token);

            case 8:
              response = _context2.sent;
              data = response.data;
              configId = data.configId;
              console.log(data);

              _this.setState({
                error: '',
                loading: false
              }, function () {
                return _this.generateQRCode(configId);
              });

              _context2.next = 19;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);

              _this.setState({
                loading: false,
                error: (0, _strings.getString)('QR_CODE_ERROR_LOAD_REFERRER')
              });

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 15]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "generateQRCode", function (referrer) {
      (0, _eqmodJsQrcodelib.generateQRCodeInCanvas)('generic', referrer, _eqmodJsQrcodelib.QR_CONTENT_TYPES.REFERRER, 'qrcanvas').then(function (code) {
        console.log(code);

        _this.startCountdown();
      })["catch"](function (e) {
        console.error(e);

        _this.setState({
          error: (0, _strings.getString)('QR_CODE_ERROR_LOAD_CODE')
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "startCountdown", function () {
      _this.setState({
        timer: START_TIMER
      }, function () {
        _this.timer = setInterval(_this.progress, 1000);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "progress", function () {
      if (_this.state.timer !== 0) {
        _this.setState(function (prevState) {
          return {
            timer: prevState.timer - 1
          };
        });
      } else {
        clearInterval(_this.timer);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(QRCodeLogin, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          error = _this$state.error,
          timer = _this$state.timer,
          start = _this$state.start;
      var completed = 100 / START_TIMER * timer;

      if (start) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: _QRCodeLogin["default"].startButton,
          onClick: this.props.forQD ? this.getQDReferrer : this.getReferrer
        }, (0, _strings.getString)('QR_CODE_HEADLINE'));
      }

      if (loading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _QRCodeLogin["default"].container
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _QRCodeLogin["default"].wrapper
        }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null)));
      }

      if (error !== '') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _QRCodeLogin["default"].container
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _QRCodeLogin["default"].errorMessage
        }, error));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeLogin["default"].container
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeLogin["default"].headline
      }, (0, _strings.getString)('QR_CODE_HEADLINE')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeLogin["default"].infotext
      }, (0, _strings.getString)('QR_CODE_INFOTEXT')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeLogin["default"].wrapper
      }, /*#__PURE__*/_react["default"].createElement("canvas", {
        id: "qrcanvas",
        className: _QRCodeLogin["default"].canvas
      }), completed !== 0 && /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], {
        color: timer < 10 ? 'secondary' : 'primary',
        variant: "determinate",
        value: completed,
        className: _QRCodeLogin["default"].progress
      })), completed ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _QRCodeLogin["default"].progressText
      }, "".concat((0, _strings.getString)('QR_CODE_PROGRESSTEXT'), "  ").concat((0, _DateTimeHelper.secondsToMinutes)(timer), " ").concat((0, _strings.getString)('QR_CODE_PROGRESS_UNIT'))) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _QRCodeLogin["default"].refreshButton,
        onClick: this.props.forQD ? this.getQDReferrer : this.getReferrer
      }, (0, _strings.getString)('QR_CODE_REFRESH')));
    }
  }]);
  return QRCodeLogin;
}(_react.Component);

QRCodeLogin.propTypes = {
  forQD: _propTypes["default"].bool
};
var _default = QRCodeLogin;
exports["default"] = _default;